import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e71a5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover-header" }
const _hoisted_2 = { class: "right-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Language = _resolveComponent("Language")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([[!this.showSelect ? 'center-button' : 'cover-div'], "left-section"])
    }, [
      _withDirectives(_createVNode(_component_Select, {
        title: 
          this.$store.state.language === 'fr'
            ? `Type d'invité `
            : 'Type of guest'
        ,
        selectItems: _ctx.guestTypes
      }, null, 8, ["title", "selectItems"]), [
        [_vShow, _ctx.showSelect]
      ]),
      _createVNode(_component_router_link, {
        to: { name: _ctx.route.name, params: { type: _ctx.route.type, id: _ctx.route.id } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            roundedStyle: this.roundedStyle,
            link: _ctx.link,
            text: _ctx.text,
            mainColor: "var(--colorPrimary)",
            hoverColor: "var(--colorPrimaryDark)",
            stateMenuNumber: _ctx.stateMenuNumber,
            stateMenuFilter: _ctx.stateMenuFilter,
            stateMenuMenu: _ctx.stateMenuMenu
          }, null, 8, ["roundedStyle", "link", "text", "stateMenuNumber", "stateMenuFilter", "stateMenuMenu"])
        ]),
        _: 1
      }, 8, ["to"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Language),
      _createVNode(_component_Select, {
        title: this.$store.state.language === 'fr' ? 'Programme' : 'Program',
        selectItems: _ctx.programs
      }, null, 8, ["title", "selectItems"])
    ])
  ]))
}